angular
	.module 'App.Filter'
	.filter 'wmProductsByCategory', [
		'$filter'
		($filter) ->
			return (products, category) ->
				return $filter('filter')(products, (product) ->
					if product.product_categories.length == 0 and category.name == 'Uncategorized'
						return true

					for element in product.product_categories
						if element.id == category.id
							return true
				)
	]
